import React from "react";
import { Container } from "react-bootstrap";
import "./Terms_Conditions.css";

const Terms_Conditions = () => {
  return (
    <>
      <section className="  terms-section">
        <div className=" card_div">
          <img
            src="/assets/images/banner/terms-conditions-banner.png"
            alt="Terms Conditions Banner"
            className="terms-banner"
          />
          <div className="card-text container">
            <div className="description_div">
              <p className="grey_class_paragraph">
                By consenting to the terms on this site (the “Website”), you are
                entering into the following Terms and Conditions established
                with MCW. PLEASE REVIEW THESE TERMS THOUGHTFULLY. If you
                disagree, please leave the site and refrain from further use.
              </p>
            </div>
            <h2 className="head_div">1. YOUR AGREEMENT</h2>
            <div className="description_div">
              <p className="grey_class">
                We reserve the right, at our sole discretion, to change, modify
                or otherwise alter these Terms and Conditions at any time.
                Unless otherwise indicated, amendments will become effective
                immediately. Please review these Terms and Conditions
                periodically. Your continued use of the Site following the
                posting of changes and/or modifications will constitute your
                acceptance of the revised Terms and Conditions and the
                reasonableness of these standards for notice of changes. For
                your information, this page was last updated as of the date at
                the top of these terms and conditions.
              </p>
            </div>
            <h2 className="head_div">2. PRIVACY</h2>
            <div className="description_div">
              <p className="grey_class">
                We use your personal details to fulfill your orders, send order
                updates, and respond to your inquiries. Please review our
                Privacy Policy, which also governs your visit to this Site, to
                understand our practices
              </p>
            </div>
            <h2 className="head_div">3. LINKED SITES</h2>
            <div className="description_div">
              <p className="grey_class">
                This Site may contain links to other independent third-party Web
                sites ("Linked Sites”). These Linked Sites are provided solely
                as a convenience to our visitors. Such Linked Sites are not
                under our control, and we are not responsible for and does not
                endorse the content of such Linked Sites, including any
                information or materials contained on such Linked Sites. You
                will need to make your own independent judgment regarding your
                interaction with these Linked Sites.
              </p>
            </div>
            <h2 className="head_div">4. FORWARD LOOKING STATEMENTS</h2>
            <div className="description_div">
              <p className="grey_class">
                {" "}
                All materials reproduced on this site speak as of the original
                date of publication or filing. The fact that a document is
                available on this site does not mean that the information
                contained in such document has not been modified or superseded
                by events or by a subsequent document or filing. We have no duty
                or policy to update any information or statements contained on
                this site and, therefore, such information or statements should
                not be relied upon as being current as of the date you access
                this site.
              </p>
            </div>
            <h2 className="head_div">
              5. DISCLAIMER OF WARRANTIES AND LIMITATION OF LIABILITY
            </h2>
            <div className="description_div">
              <p className="grey_class">
                A. THIS SITE MAY CONTAIN INACCURACIES AND TYPOGRAPHICAL ERRORS.
                WE DOES NOT WARRANT THE ACCURACY OR COMPLETENESS OF THE
                MATERIALS OR THE RELIABILITY OF ANY ADVICE, OPINION, STATEMENT
                OR OTHER INFORMATION DISPLAYED OR DISTRIBUTED THROUGH THE SITE.
                YOU EXPRESSLY UNDERSTAND AND AGREE THAT: (i) YOUR USE OF THE
                SITE, INCLUDING ANY RELIANCE ON ANY SUCH OPINION, ADVICE,
                STATEMENT, MEMORANDUM, OR INFORMATION CONTAINED HEREIN, SHALL BE
                AT YOUR SOLE RISK; (ii) THE SITE IS PROVIDED ON AN "AS IS" AND
                "AS AVAILABLE" BASIS; (iii) EXCEPT AS EXPRESSLY PROVIDED HEREIN
                WE DISCLAIM ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR
                IMPLIED, INCLUDING, BUT NOT LIMITED TO IMPLIED WARRANTIES OF
                MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, WORKMANLIKE
                EFFORT, TITLE AND NON-INFRINGEMENT; (iv) WE MAKE NO WARRANTY
                WITH RESPECT TO THE RESULTS THAT MAY BE OBTAINED FROM THIS SITE,
                THE PRODUCTS OR SERVICES ADVERTISED OR OFFERED OR MERCHANTS
                INVOLVED; (v) ANY MATERIAL DOWNLOADED OR OTHERWISE OBTAINED
                THROUGH THE USE OF THE SITE IS DONE AT YOUR OWN DISCRETION AND
                RISK; and (vi) YOU WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO
                YOUR COMPUTER SYSTEM OR FOR ANY LOSS OF DATA THAT RESULTS FROM
                THE DOWNLOAD OF ANY SUCH MATERIAL.
              </p>
            </div>

            <h2 className="head_div">6. EXCLUSIONS AND LIMITATIONS</h2>
            <div className="description_div">
              <p className="grey_class">
                SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN
                WARRANTIES OR THE LIMITATION OR EXCLUSION OF LIABILITY FOR
                INCIDENTAL OR CONSEQUENTIAL DAMAGES. ACCORDINGLY, OUR LIABILITY
                IN SUCH JURISDICTION SHALL BE LIMITED TO THE MAXIMUM EXTENT
                PERMITTED BY LAW.
              </p>
            </div>

            <h2 className="head_div">7. OUR PROPRIETARY RIGHTS</h2>
            <div className="description_div">
              <p className="grey_class">
                This Site and all its Contents are intended solely for personal,
                non-commercial use. Except as expressly provided, nothing within
                the Site shall be construed as conferring any license under our
                or any third party's intellectual property rights, whether by
                estoppel, implication, waiver, or otherwise. Without limiting
                the generality of the foregoing, you acknowledge and agree that
                all content available through and used to operate the Site and
                its services is protected by copyright, trademark, patent, or
                other proprietary rights. You agree not to: (a) modify, alter,
                or deface any of the trademarks, service marks, trade dress
                (collectively "Trademarks") or other intellectual property made
                available by us in connection with the Site; (b) hold yourself
                out as in any way sponsored by, affiliated with, or endorsed by
                us, or any of our affiliates or service providers; (c) use any
                of the Trademarks or other content accessible through the Site
                for any purpose other than the purpose for which we have made it
                available to you; (d) defame or disparage us, our Trademarks ,
                or any aspect of the Site; and (e) adapt, translate, modify,
                decompile, disassemble, or reverse engineer the Site or any
                software or programs used in connection with it or its products
                and services.
              </p>
            </div>

            <h2 className="head_div">8. INDEMNITY</h2>
            <div className="description_div">
              <p className="grey_class">
                By using the Site web sites you agree to indemnify us and
                affiliated entities (collectively "Indemnities") and hold them
                harmless from any and all claims and expenses, including
                (without limitation) attorney's fees, arising from your use of
                the Site web sites, your use of the Products and Services, or
                your submission of ideas and/or related materials to us or from
                any person's use of any ID, membership or password you maintain
                with any portion of the Site, regardless of whether such use is
                authorized by you.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Terms_Conditions;
